import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import { useMediaQuery } from 'src/lib/use-media-query'
import common from 'src/styles/common.module.scss'

export const TextHeaderRo = () => {
    const isDesktop = useMediaQuery('(min-width: 768px)')

    return (
        <HighlightedText
            text="ÎNTORCEȚI ROATA ȘI PRIMIȚI ROTIRI GRATUITE"
            highlights={[{ word: 'ROTIRI' }, { word: 'GRATUITE' }]}
            breakAfterWords={isDesktop ? ['PRIMIȚI'] : ['ȘI']}
            className={common.text_header}
        />
    )
}
